module.exports = __webpack_public_path__ + "img/pencil.220b632c.svg";